import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GeneratingReport, OrderSummary, StripeElements } from './fragments';
import { authActions } from 'store';

export const OrderNow = () => {
    const [showStripe, setShowStripe] = useState(false);
    const [isBothReports, setIsBothReports] = useState(false);

    const dispatch = useDispatch();
    const token = localStorage.getItem('access-token');

    useEffect(() => {
        if(token) {
            dispatch(authActions.getPaymentMethod());
        }
    }, []);

    return (
        <div className='order-now-page'>
            {/*<BannerOrderNow />*/}
            <div className='container'>
                <div className='order-now-content'>
                    {showStripe ?
                        <StripeElements
                            setShowStripe={setShowStripe}
                            isBothReports={isBothReports}
                        />
                        :
                        <GeneratingReport
                            setShowStripe={setShowStripe}
                            isBothReports={isBothReports}
                            setIsBothReports={setIsBothReports}
                        />
                    }
                    <OrderSummary isBothReports={isBothReports} />
                </div>
            </div>
        </div>
    );
};

